export function getRegistrationEndpoint(): string {
    return '/register';
}

export function getRegistrationWithInvitationEndpoint(): string {
    return '/register-invited-user';
}
